import { isArray } from "lodash";

export const searchIndex = (array, key) => {
    if (isArray(array))
        if (array.length > 0) {
            return array.findIndex((e) => e.value === key);
        } else {
            return null;
        }
}